import React, { useState } from "react";
// import "./project6.css";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";

function Project7() {
  const [main, setMain] = useState(false);
  const gotoMainPage = () => {
    setMain(true);
  };

  return (
    <>
      {!main ? (
        <div className="body">
          <div className="headerP1">
            <h2 id="Title">FISC Assembler and Simulator</h2>
            <div id="P1Github">
              <a
                href="https://github.com/AkhilTheBoss/FISC-Assembler-and-Simulator"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="secondary">Github</Button>
              </a>
            </div>
            <div id="mainPage">
              <Button variant="primary" onClick={gotoMainPage}>
                Main Page
              </Button>
            </div>
          </div>
          <br />
          <h4 className="Heading">Introduction</h4>
          <p className="Content">
            Created an Assembler that converts FISC assembly code into
            hexadecimal values and created a simulator that converts hexadecimal
            values and displays the execution of the program line by line.
          </p>
          <h4 className="Heading">Explanation</h4>
          <p className="Content">
            <div>
              I've developed an assembler for translating FISC (Four Instruction
              Set Computers) assembly code into hexadecimal format. The process
              involves taking an input assembly file and producing an output
              file containing hexadecimal values. The assembler follows a two
              cycle process:
              <div>
                1. Label Resolution: In the first step, it identifies and
                resolves the line numbers associated with labels within the
                assembly code. This step is very important for an accurate
                translation to assembly language.
              </div>
              <div>
                2. Code Translation: Following label resolution, the assembler
                proceeds to convert the assembly code into machine code. Once
                the machine code is generated, it is further converted into
                hexadecimal values. These hexadecimal values represent the final
                output and is subsequently written to the output file.
              </div>
            </div>
            <div>
              Additionally, I've created a simulator that provides a
              step-by-step execution visualization of the program. This
              simulator takes the assembler-generated hexadecimal file as input,
              converts it back into machine code, and provides a comprehensive
              overview of the program's execution. It displays the values of
              each register, the status of the zero flag (zero flag is set to 1
              if the value of the destination register of the previous register
              is 0 else the zero flag is 0), and the program counter's value
              after each instruction's execution. Furthermore, the simulator
              acts as a disassembler by generating corresponding assembly
              instructions for the provided machine code.
            </div>
          </p>
          <h4 className="Heading">How to run it?</h4>
          <p className="Content">
            <div>Command to run the assembler:</div>
            <div>./a.out t2.s pp.hex</div>
            <p>
              t2.s is the input assembly file and pp.hex is the hexadecimal file
              produced as an output.
            </p>
            <div>If you do not want to write to the output file:</div>
            <div>./a.out t2.s pp.hex -l</div>
            <p>This produces the output:</p>
            <div>*** LABEL LIST ***</div>
            <div>endloop : 11</div>
            <div>loop : 5</div>
            <div>start : 0</div>
            <div>*** MACHINE LIST ***</div>
            <div>0:90 not r0 r1</div>
            <div>1:44 and r0 r0 r1</div>
            <div>2:81 not r1 r0</div>
            <div>3:15 add r1 r1 r1</div>
            <div>4:91 not r1 r1</div>
            <div>5:43 and r3 r0 r0</div>
            <div>6:1c add r0 r1 r3</div>
            <div>7:cb bnz endloop</div>
            <div>8:7f and r3 r3 r3</div>
            <div>9:b2 not r2 r3</div>
            <div>10:6d and r1 r2 r3</div>
            <div>11:00 add r0 r0 r0</div>
            <div>
              However, nothing will be written to the output file pp.hex. The
              LABEL LIST is printed in the first cycle and MACHINE LIST is
              printed in the second cycle.
            </div>
            <br />
            <div>Command to run the simulator:</div>
            <p>./a.out pp.hex</p>
            <div>The above command will output:</div>
            <div>Cycle: 1 State:PC:1 Z: 0 R0: ff R1: 0 R2: 0 R3: 0</div>
            <div>Disassembly: not r0 r1</div>
            <div>Cycle: 2 State:PC:2 Z: 1 R0: 0 R1: 0 R2: 0 R3: 0</div>
            <div>Disassembly: and r0 r0 r1</div>
            <div>Cycle: 3 State:PC:3 Z: 0 R0: 0 R1: ff R2: 0 R3: 0</div>
            <div>Disassembly: not r1 r0</div>
            <div>Cycle: 4 State:PC:4 Z: 0 R0: 0 R1: fe R2: 0 R3: 0</div>
            <div>Disassembly: add r1 r1 r1</div>
            <div>Cycle: 5 State:PC:5 Z: 0 R0: 0 R1: 1 R2: 0 R3: 0</div>
            <div>Disassembly: not r1 r1</div>
            <div>Cycle: 6 State:PC:6 Z: 1 R0: 0 R1: 1 R2: 0 R3: 0</div>
            <div>Disassembly: and r3 r0 r0</div>
            <div>Cycle: 7 State:PC:7 Z: 0 R0: 1 R1: 1 R2: 0 R3: 0</div>
            <div>Disassembly: add r0 r1 r3</div>
            <div>Cycle: 8 State:PC:8 Z: 0 R0: 1 R1: 1 R2: 0 R3: 0</div>
            <div>Disassembly: bnz 11</div>
            <div>Cycle: 9 State:PC:12 Z: 0 R0: 2 R1: 1 R2: 0 R3: 0</div>
            <p>Disassembly: add r0 r0 r0</p>
            <p>
              However, if you want all the cycles to print as it might take too
              much time. You can specify the number of cycles to print in the
              command line argument.
            </p>
            <div>Command line argument:</div>
            <p>./a.out pp.hex 5</p>
            <div>The above command will output:</div>
            <div>Cycle: 1 State:PC:1 Z: 0 R0: ff R1: 0 R2: 0 R3: 0</div>
            <div>Disassembly: not r0 r1</div>
            <div>Cycle: 2 State:PC:2 Z: 1 R0: 0 R1: 0 R2: 0 R3: 0</div>
            <div>Disassembly: and r0 r0 r1</div>
            <div>Cycle: 3 State:PC:3 Z: 0 R0: 0 R1: ff R2: 0 R3: 0</div>
            <div>Disassembly: not r1 r0</div>
            <div>Cycle: 4 State:PC:4 Z: 0 R0: 0 R1: fe R2: 0 R3: 0</div>
            <div>Disassembly: add r1 r1 r1</div>
            <div>Cycle: 5 State:PC:5 Z: 0 R0: 0 R1: 1 R2: 0 R3: 0</div>
            <div>Disassembly: not r1 r1</div>
          </p>
          <h4 className="Heading">Opcode value for every operand/operator</h4>
          <p className="Content">
            <ul>
              <li>ADD: 00</li>
              <li>AND: 01</li>
              <li>NOT: 10</li>
              <li>BNZ: 11</li>
              <li>R0: 00</li>
              <li>R1: 01</li>
              <li>R2: 10</li>
              <li>R3: 11</li>
            </ul>
          </p>
          <h4 className="Heading">How are machine instructions formed?</h4>
          <p className="Content">
            <ul>
              <li>
                <strong>ADD: </strong> opcode of ADD + opcode of source register
                1 + opcode of source register 2 + opcode of destination register
              </li>
              <li>
                <strong>AND: </strong> opcode of AND + opcode of source register
                1 + opcode of source register 2 + opcode of destination register
              </li>
              <li>
                <strong>NOT: </strong> opcode of NOT + opcode of source register
                1 + 00 + opcode of destination register
              </li>
              <li>
                <strong>BNZ: </strong> opcode of BNZ + label value
              </li>
            </ul>
          </p>
        </div>
      ) : (
        <App />
      )}
    </>
  );
}

export default Project7;
